export default __webpack_public_path__ + "static/ak-cached/24h/media/care-bannerV2.e2031b85.jpg";